<template>
  <div class="container-xl">
    <Card title="Webhooks" subtitle="Cadastro de chamadas que serão enviadas quando houverem eventos nos dispositivos">
      <table class="table table-sm table-hover table-striped">
        <thead>
          <tr>
            <PkHeader/>
            <EditHeader/>
            <DeleteHeader/>
            <StatusHeader/>
            <th data-column-id="name" data-sortable="true">Nome</th>
            <th data-column-id="method" data-sortable="true">Método</th>
            <th data-column-id="url" data-sortable="true">URL</th>
            <th data-column-id="verify_ssl">Verificar SSL</th>
          </tr>
        </thead>
      </table>

    </Card>
  </div>
</template>

<script>
import $ from 'jquery'
import { initGrid } from 'hennig-common'
import PkHeader from '@/components/grid/PkHeader'
import EditHeader from '@/components/grid/EditHeader'
import DeleteHeader from '@/components/grid/DeleteHeader'
import StatusHeader from '@/components/grid/StatusHeader'
import Card from '@/components/Card'

export default {
  name: 'Webhooks',
  components: {
    Card,
    StatusHeader,
    DeleteHeader,
    EditHeader,
    PkHeader
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const addLabel = 'Adicionar chamada'
      const collectionObj = 'Webhook'
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        addLabel
      })
    }
  }
}
</script>
